import React from 'react';
import PropTypes from 'prop-types';

import { ProducerTeaser } from '/components/producer-teaser/components';

import '/components/map/styles/map-marker.scss';

const MapMarker = ({ title, onClick, theme, producer, active }) => (
    <div className="map-marker-wrapper">
        <button className={`map-marker theme-${theme} ${active ? 'is-active' : ''}`} onClick={onClick}>
            <span className="visually-hidden">{title}</span>
            <svg viewBox="0 0 32 48">
                <path fill="#f1efe9" d="M9 10h14v14H9z"/>
                <path d="M16 0C7.18 0 0 7.18 0 16c0 14.11 14.63 30.95 15.25 31.66A1 1 0 0016 48c.31-.02.57-.13.76-.35C17.38 46.93 32 29.81 32 16c0-8.82-7.18-16-16-16zm0 23a6 6 0 110-12 6 6 0 010 12z" />
            </svg>
        </button>
        {active && (
            <div className="map-marker-teaser">
                <ProducerTeaser producer={producer} />
                <button
                    className="map-marker-teaser__close"
                    onClick={() => { window.setActiveHit(null); }}
                >
                    <svg viewBox="0 0 30 30">
                        <use xlinkHref="#icon-close" />
                    </svg>
                </button>
            </div>
        )}
    </div>
);

MapMarker.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    theme: PropTypes.string,
};

MapMarker.defaultProps = {
    onClick: '',
    theme: 'red',
};

export { MapMarker };
